module.exports = __webpack_public_path__ + "img/antes_despues_25.a7814240.png";